export default __webpack_public_path__ + "static/media/Payment.fe28664b.jpg";